module.exports = __webpack_public_path__ + "b59ea7c8a27b705cd81ef550fe4e18ea.png";